import React from 'react';
import PropTypes from 'prop-types';
import { FaCaretDown } from 'react-icons/fa';
import classNames from 'classnames';
/*
This component is only used here for a custom dropdown toggle. And needs to be a component
https://5c507d49471426000887a6a7--react-bootstrap.netlify.com/components/dropdowns/#btn-dropdowns-custom
*/
export default class HoverToggle extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    title: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
  };
  static defaultProps = {
    onClick: () => {},
    title: null,
    children: null,
    className: '',
  };
  handleClick = e => {
    e.preventDefault();
    // e.stopPropagation();
    const { onClick } = this.props;
    onClick(e);
  };
  render() {
    const { title, children, className } = this.props;
    return (
      <span title={title} onClick={this.handleClick} className={classNames('clickable', className)}>
        {children}
        <span className="react-icon hover-toggle">
          <FaCaretDown />
        </span>
      </span>
    );
  }
}
